/* ============================================================
   Collection — JS original (Stratégie 2)
   Filtres + tri en AJAX via Section Rendering API
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var sectionId = root.dataset.sectionId;
    var filterForm = root.querySelector('[data-lf-filter-form]');
    var sortForm = root.querySelector('[data-lf-sort]');
    var toggle = root.querySelector('[data-lf-filter-toggle]');
    var debounce;

    /* Le tiroir de filtres est un calque : le focus y reste tant qu'il est
       ouvert et revient ensuite au bouton de la barre. Il n'avait ni piege
       ni touche Echap, et Tab partait sur la grille de produits masquee. */
    var ouvreurFiltres = null;

    function ouvrirFiltres(panel, declencheur, cibleFocus) {
      panel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      root.querySelectorAll('[data-lf-filter-toggle][aria-expanded]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
      });
      if (window.lfCalque) window.lfCalque.ouvrir(panel, { retour: declencheur, focus: cibleFocus });
    }

    function fermerFiltres(panel) {
      panel.classList.remove('is-open');
      document.body.style.overflow = '';
      root.querySelectorAll('[data-lf-filter-toggle][aria-expanded]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      if (window.lfCalque) window.lfCalque.fermer(panel);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var panel = root.querySelector('[data-lf-filters].is-open');
      if (panel) fermerFiltres(panel);
    });

    function buildUrl() {
      var params = new URLSearchParams();

      if (filterForm) {
        new FormData(filterForm).forEach(function (val, key) {
          if (val !== '' && val != null) params.append(key, val);
        });
      }
      if (sortForm) {
        var sel = sortForm.querySelector('select');
        if (sel && sel.value) params.set('sort_by', sel.value);
      }
      var qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    function apply(url) {
      root.classList.add('is-loading');
      var ancienPanneau = root.querySelector('[data-lf-filters]');
      var wasOpen = ancienPanneau && ancienPanneau.classList.contains('is-open');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // La case cochee est remplacee avec tout le tiroir : on retient son
          // identifiant pour lui rendre le focus dans le nouveau rendu.
          var actif = document.activeElement;
          var idFocus = actif && ancienPanneau && ancienPanneau.contains(actif) ? actif.id : '';
          swap(doc, '[data-lf-results]');
          swap(doc, '[data-lf-filters]');
          swap(doc, '.lf-col__count');
          window.history.replaceState({}, '', url);
          root.classList.remove('is-loading');
          rebind();
          if (wasOpen) {
            var panel = root.querySelector('[data-lf-filters]');
            if (window.lfCalque && ancienPanneau !== panel) window.lfCalque.fermer(ancienPanneau, { sansRetour: true });
            if (panel) ouvrirFiltres(panel, ouvreurFiltres, idFocus ? document.getElementById(idFocus) : null);
          }
        })
        .catch(function () { root.classList.remove('is-loading'); });
    }

    function swap(doc, sel) {
      var fresh = doc.querySelector(sel);
      var cur = root.querySelector(sel);
      if (fresh && cur) cur.replaceWith(fresh);
    }

    function majLibelleTri(champ) {
      var forme = champ.closest('[data-lf-sort]');
      if (!forme) return;
      var face = forme.querySelector('.lf-col__sort-face');
      var choisie = champ.options && champ.options[champ.selectedIndex];
      if (face && choisie) face.textContent = choisie.text;
    }

    // Re-cibler les formulaires après remplacement DOM
    function rebind() {
      filterForm = root.querySelector('[data-lf-filter-form]');
      sortForm = root.querySelector('[data-lf-sort]');
    }

    // Délégation : survit aux remplacements DOM
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-lf-filter-form]')) {
        clearTimeout(debounce);
        debounce = setTimeout(function () { apply(buildUrl()); }, 350);
      } else if (e.target.closest('[data-lf-sort]')) {
        /* Le libelle visible du tri est un element a part : le « select »
           qui le recouvre est transparent, faute de quoi aucun navigateur
           n'en peindrait le trait. Il ne se met donc pas a jour tout seul,
           et le rafraichissement AJAX ne remplace pas ce formulaire. Sans
           cette ligne, choisir « Price, high to low » reordonnait bien la
           grille mais laissait ecrit « Alphabetically, A-Z ». On l'ecrit
           tout de suite plutot qu'au retour du reseau : le libelle suit
           le doigt, pas la latence. */
        majLibelleTri(e.target);
        apply(buildUrl());
      }
    });

    root.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-lf-filter-clear]');
      if (clear) {
        e.preventDefault();
        apply(clear.getAttribute('href'));
        return;
      }
      var tg = e.target.closest('[data-lf-filter-toggle]');
      if (tg) {
        var panel = root.querySelector('[data-lf-filters]');
        if (panel) {
          if (panel.classList.contains('is-open')) {
            fermerFiltres(panel);
          } else {
            ouvreurFiltres = tg;
            ouvrirFiltres(panel, tg);
          }
        }
      }
    });
  }

  /* Aligne la hauteur du média des "produits larges" sur une carte voisine
     → le bloc nom se retrouve à la même ligne, quel que soit le ratio (même "adapt"). */
  function matchWideHeights() {
    document.querySelectorAll('.lf-col__grid').forEach(function (grid) {
      grid.querySelectorAll('.lf-col__item--autoratio').forEach(function (wide) {
        function isWide(el) { return el && (/--wide/.test(el.className) || el.classList.contains('lf-col__promo')); }
        var ref = wide.previousElementSibling;
        while (isWide(ref)) ref = ref.previousElementSibling;
        if (!ref) {
          ref = wide.nextElementSibling;
          while (isWide(ref)) ref = ref.nextElementSibling;
        }
        var wm = wide.querySelector('.lf-card__media');
        if (!wm || !ref) return;
        var rm = ref.querySelector('.lf-card__media');
        if (!rm) return;
        var h = rm.getBoundingClientRect().height;
        /* La largeur est fixée en même temps que la hauteur : sans elle, une
           règle de rapport d'image laissée ailleurs peut recalculer la
           largeur à partir de la hauteur et ramener le pavé à une colonne. */
        if (h > 0) {
          wm.style.aspectRatio = 'auto';
          wm.style.height = h + 'px';
          wm.style.width = '100%';
        }
      });
    });
  }

  var matchScheduled = false;
  function scheduleMatch() {
    if (matchScheduled) return;
    matchScheduled = true;
    requestAnimationFrame(function () { matchScheduled = false; matchWideHeights(); });
  }

  function observeGrids() {
    document.querySelectorAll('.lf-col__grid').forEach(function (grid) {
      if (grid.dataset.lfMatch) return;
      grid.dataset.lfMatch = '1';
      // Rejoue l'alignement quand une image finit de charger (corrige la marge qui "saute")
      grid.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', scheduleMatch, { once: true });
      });
      // Et quand la grille change de taille (chargement, resize, filtres…)
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(scheduleMatch);
        ro.observe(grid);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-lf-collection]').forEach(init);
    matchWideHeights();
    requestAnimationFrame(matchWideHeights);
    observeGrids();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', scheduleMatch);
  window.addEventListener('resize', function () { setTimeout(scheduleMatch, 150); }, { passive: true });
  document.addEventListener('shopify:section:load', boot);
})();
